module.exports = __webpack_public_path__ + "img/4.c9304336.jpg";